<template>
  <div class="comment-item-component"
       @click="clickReviewContent(showReply, item)"
  >
    <div class="comment-item-content">
      <ym-avatar class="user-avatar"
                 :avatar="item.user.avatar"
                 :name="item.user.name"
                 size="small"
      />
      <div class="comment-content"
           @click.stop="clickReviewContent(showReply, item)"
      >
        <div class="user-name ym-line-ellipsis">{{ item.user.name }}</div>
        <div class="content"
             :class="{ 'ym-four-line-ellipsis': limitContentLine }"
        >
          {{ item.content }}
          <div class="quote-content"
               v-if="item.quote.content.length > 0"
               @click.stop="clickQuoteContent(showReply, 'quote')"
          >
            <div class="user-name strong">{{ item.quote.user.name }}</div>
            <div class="content">{{ item.quote.content }}</div>
          </div>
        </div>
        <div class="comment-desc ym-line-ellipsis"
             v-if="showComeFrom"
        >
          来自：
          <template v-if="item.program.showSeq > 0">
            第{{ item.program.showSeq }}讲 |
          </template> {{ item.program.title }}
        </div>
        <div class="comment-reply"
             v-else
        >
            <span class="date"
                  v-if="item.createdTime"
            >
              {{ item.createdTime | formatTime('yyyy-MM-dd') }}
            </span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Avatar from '@/components/Avatar';

  export default {
    name: 'ProgramCommentItem',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      showComeFrom: {
        type: Boolean,
        default: false,
      },
      showReply: {
        type: Boolean,
        default: false,
      },
      limitContentLine: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters([
        'userId',
      ]),
    },
    methods: {
      clickReviewContent(showReply, item) {
        if (!showReply) return;
        this.$emit('reply', { id: item.id, name: item.user.name, userId: item.user.id });
      },
      clickQuoteContent(showReply, type) {
        if (!showReply) return;
        this.$emit('reply', { type });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .comment-item-component {
    padding: @size-small 0;
    &:not(:last-child) {
      border-bottom: @border-base;
    }
  }

  .comment-item-content {
    display: flex;
  }

  .user-avatar {
    flex-shrink: 0;
    margin-right: @size-base;
  }

  .comment-content {
    flex: 1;
    align-self: stretch;
    overflow: hidden;
  }

  .content {
    color: @color-text-base;
    font-size: @font-size-base;
  }

  .user-name {
    margin-bottom: @size-extra-small;
    font-size: @font-size-small;
    color: @color-text-light;
    &.strong {
      border-left: 6px solid @border-color-primary;
      padding-left: @size-extra-small;
    }
  }

  .quote-content {
    margin-top: @size-small;
    padding-top: @size-small;
    border-top: @border-base;
  }

  .comment-desc {
    color: @color-text-lighter;
    font-size: @font-size-extra-extra-small;
    line-height: 1.2;
    margin-top: @size-small;
    padding: (@size-extra-small - 2) / 2 @size-extra-small;
    display: inline-block;
    background: @background-color-base;
    border-radius: @border-radius-base;
  }

  .comment-reply {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: @size-extra-small;
    color: @color-text-lighter;
    font-size: @font-size-extra-small;
  }

  .comment-btn {
    color: @color-text-light;
    &:active {
      color: @color-text-lighter;
    }
  }

</style>
